export default {"src":"/_next/static/media/racoon_email_verified.97947e60.svg","height":125,"width":125};